import { ReportesEstablecimientosService } from './../establecimientos/reportes-establecimientos.service';
import { ReportesRntsService } from './reportes-rnts.service';
import { ModuloAyudaService } from './../../configuracion/modulo-ayuda/modulo-ayuda.service';
import { DocumentoSubcategoriaService } from './../../configuracion/documento-subcategoria/documento-subcategoria.service';
import { CampoAdicionalCategoriaService } from './../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service';
import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { UsuarioService } from '../../configuracion/usuario/usuario.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AccionRntService } from '../../configuracion/accion-rnt/accion-rnt.service';
import * as FileSaver from 'file-saver';
import { HttpEventType } from '@angular/common/http';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CompletaInformacionService } from '../../../prestador/pasos/completa-informacion/completa-informacion.service';

@Component({
	// tslint:disable-next-line:indent
	selector: 'app-reportes-rnts',
	// tslint:disable-next-line:indent
	templateUrl: './reportes-rnts.component.html',
	// tslint:disable-next-line:indent
	styleUrls: ['./reportes-rnts.component.scss']
})
export class ReportesRntsComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerTabla: Array<string>;
	formUsuario: FormGroup;
	camarasLista: Array<CamaraComercioEntry>;
	paginaActual: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	prestador = RolesUsuario.Prestador;
	adminCC = RolesUsuario.AdministradorCC;
	columnas: Array<any> = [];
	columnasEnvio: any;
	// filtros
	filtro: FormGroup;
	formCheck: FormGroup;
	public isCollapsed = true;
	isExportar = true;
	camaraComercio: string;
	// selects
	categoria: Array<any> = [];
	subcategoria: Array<any> = [];
	estadoRnt: Array<any> = [];
	tipoRNT: Array<any> = [];
	// checkBox
	camaraCheck = false;
	razonSocialCheck = false;
	nitCheck = false;
	departamentoCheck = false;
	municipioCheck = false;
	tipoRntCheck = false;
	numeroRntCheck = false;
	categoriaCheck = false;
	subcategoriaCheck = false;
	estadoRntCheck = false;
	fecha_inicio: any;
	isSelect: boolean;
	exportarForm: FormGroup;
	exportarList = [
		{ id: 'Descripcion_Camara', name: 'Cámara de Comercio' },
		{ id: 'Razon_Social', name: 'Nombre o razón social' },
		{ id: 'Numero_Identificacion', name: 'Nit' },
		{ id: 'Matricula', name: 'Número Matrícula' },
		{ id: 'Descripcion_Departamento', name: 'Departamento' },
		{ id: 'Desc_Municipio', name: 'Municipio' },
		{ id: 'Descripcion_Tipo_Rnt', name: 'Tipo Rnt' },
		{ id: 'Codigo_Rnt', name: 'Número Rnt' },
		{ id: 'Fecha_Aprobacion', name: 'Fecha aprobación' },
		{ id: 'Descripcion_Categoria', name: 'Categoría' },
		{ id: 'Descripcion_Subcategoria', name: 'Subcategoría' },
		{ id: 'Descripcion_Estado_Rnt', name: 'Estado Rnt' },
		{ id: 'Numero_Identificacion_Representante_Legal', name: 'Identificación Rl' },
		{ id: 'Nombre_Representante_Legal', name: 'Nombre Rl' },
		{ id: 'Correo_Electronico', name: 'Correo Electrónico 1' },
		{ id: 'Correo_Electronico_Reportado', name: 'Correo Electrónico 2' },
		{ id: 'Telefono_Reportado_1', name: 'Teléfono 1' },
		{ id: 'Telefono_Reportado_2', name: 'Teléfono 2' },
		{ id: 'Direccion_Comercial', name: 'Dirección Comercial' },
		{ id: 'Direccion_Notificacion', name: 'Dirección Notificación' },
		{ id: 'Numero_Identificacion_Depositario', name: 'Identificación Depositario' },
		{ id: 'Nombre_Depositario', name: 'Nombre Depositario' },
		{ id: 'Correo_Electronico_Depositario', name: 'Correo Electrónico Depositario' },
	];

	constructor(private formBuilder: FormBuilder, private usuarioService: UsuarioService, private reporteService: ReportesRntsService,
		private establecimientoComercioService: EstablecimientoComercioService, public authService: AuthService,
		private categoriaService: CampoAdicionalCategoriaService, private subcategoriaService: DocumentoSubcategoriaService,
		private estadoRntService: AccionRntService, private tipoRntService: ModuloAyudaService,
		private subCategoriaxCategoriaService: ReportesEstablecimientosService) {

		this.createPagingTable();
		this.createForm();

		const selectAllControl = new FormControl(false);
		const formControl = this.exportarList.map(control => new FormControl(false));
		this.exportarForm = this.formBuilder.group({
			exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
			selectAll: selectAllControl
		});

		this.paginaActual = 1;
	}

	ngOnInit() {
		this.titleTable();
		this.onCamaraSelect();
		this.onCategoriaSelect();
		this.onSubcategoriaSelect();
		this.onEstadoRNTSelect();
		this.onTipoRNTSelect();
		this.onChanges();
    this.onConsultarRNT(1);
	}

	createForm() {
		this.filtro = this.formBuilder.group({
			codigo_camara: [null],
			codigo_rnt: [null],
			tipo_rnt_id: [null],
			numero_identificacion: [null],
			matricula: [null],
			razon_social: [null],
			estado_rnt_id: [null],
			categoria_id: [null],
			sub_categoria_id: [null],
			fecha_cambio_estado: [null],
			fecha_cambio_estado_inicial: [null],
			fecha_cambio_estado_final: [null],
      fecha_Aprobacion_Radicacion_inicial: [null],
      fecha_Aprobacion_Radicacion_Final: [null]
		});

	}

	createPagingTable() {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
	}

	onConsultarRNT(page: number) {
		this.reporteService.getDataTable({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarRNT(value);
	}

	filtrar() {
		this.paginaActual = 1;
		this.createPagingTable();
		this.onConsultarRNT(1);
	}

	limpiar() {
		this.filtro.reset();
		this.createPagingTable();
		this.titleTable();
		this.onCamaraSelect();
		this.onCategoriaSelect();
		this.onSubcategoriaSelect();
		this.onEstadoRNTSelect();
		this.onTipoRNTSelect();
	}

	titleTable() {
		this.headerTabla = ['Cámara de comercio', 'Nombre o Razón social', 'Nit', 'Número Matrícula',
			'Departamento', 'Municipio', 'Tipo RNT', 'Número RNT', 'Fecha aprobación', 'Categoría', 'Subcategoría',
			'Estado RNT', 'Identificación RL', 'Nombre RL', 'Correo electrónico 1', 'Correo electrónico 2',
			'Teléfono 1', 'Teléfono 2', 'Identificación Depositario', 'Nombre Depositario', 'Correo Electrónico Depositario'];
	}

  // cargar camara por default
	onCamaraSelect() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
				if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
					this.filtro.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					this.camaraComercio = (this.camarasLista.find(x => x.codigo_camara ===
						this.authService.getCamaraUser()).desc_camara);
				}
			}
		});
	}

	onCategoriaSelect() {
		this.categoriaService.getCategoria().subscribe(resultado => {
			if (resultado.result) {
				this.categoria = resultado.data;
			}
		});
	}

	onSubcategoriaSelect() {
		// tslint:disable-next-line:triple-equals
		if (this.filtro.value.categoria_id == null) {
			this.subcategoriaService.getSubCategoria().subscribe(resultado => {
				if (resultado.result) {
					this.subcategoria = resultado.data;
				}
			});
		} else {
			this.subCategoriaxCategoriaService.getSubcategoriasXCategoria(this.filtro.value.categoria_id)
				.subscribe(resultado => {
					if (resultado.result) {
						this.subcategoria = resultado.data;
					}
				});
		}
	}

	onEstadoRNTSelect() {
		this.estadoRntService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estadoRnt = resultado.data;
			}
		});
	}

	onTipoRNTSelect() {
		this.tipoRntService.getTipoRnt().subscribe(resultado => {
			if (resultado.result) {
				this.tipoRNT = resultado.data;
			}
		});
	}

	onChanges() {
		this.exportarForm.get('selectAll').valueChanges.subscribe(bool => {
			this.exportarForm
				.get('exportarList')
				.patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
		});

		this.exportarForm.get('exportarList').valueChanges.subscribe(val => {
			const allSelected = val.every(bool => bool);
			if (this.exportarForm.get('selecAll').value !== allSelected) {
				this.exportarForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}

	minSelectCheckbox(min = 1) {
		const validator: ValidatorFn = (formArray: FormArray) => {
			const totalSelected = formArray.controls.map(control => control.value)
				.reduce((prev, next) => next ? prev + next : prev, 0);

			return totalSelected >= min ? null : { required: true };
		};
		return validator;
	}

	submit() {
		const selectedPreferences = this.exportarForm.value.exportarList
			.map((checked, index) => checked ? this.exportarList[index].id : null)
			.filter(value => value !== null);

		this.columnasEnvio = selectedPreferences.join();

		this.reporteService.generarExportarRnt({ ...this.filtro.value, columnas: this.columnasEnvio })
			.subscribe(resultado => {
				if (resultado.type === HttpEventType.Response) {
					if (resultado.ok) {
						this.saveAsExcelFile(resultado.body, `reporte_rnt.xlsx`);
					}
				}
			});

	}

	private saveAsExcelFile(data: any, fileName: string): void {
		FileSaver.saveAs(data, fileName);
	}

	onCheckDate(minDate: NgbDate) {
		this.fecha_inicio = { day: minDate.day, month: minDate.month, year: minDate.year };
	}

}
